import React, { Component } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth, scrollToTop } from "../Helpers/SettingHelper";
import { computeFilterFromHex } from '../Helpers/cssFilterSolver';
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
	  />
	);
  };


class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
	    //const colorId = (typeof this.props.params.ID === 'undefined') ? '' : this.props.params.ID;
		// const colorId = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
		const colorId = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		this.state = {
            colorId: colorId,
			name:'',
			primaryColor:'',
			secondaryColor:'',
			svgImgFilter:'',
			selectedOption:{ value: 'active', label: 'Active'},
			priority: '',
			selectedvalue:''
		};
		var qs = require('qs');
		var themecolorid = this.state.colorId;

		axios.get(apiUrl+"themecolormanagement/listdetail?id="+themecolorid).then(res => {
			this.setState({primaryColor:res.data.themecolorlist.primaryColor, secondaryColor:res.data.themecolorlist.secondaryColor, priority : res.data.themecolorlist.priority});
			if(res.data.themecolorlist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}
			if(res.data.themecolorlist.secondaryColor){
				const hex = res.data.themecolorlist.secondaryColor;			
				const { filter, loss } = computeFilterFromHex(hex);
				this.setState({ secondaryFilter: filter, secondaryLoss: loss });
			}
		}); 		
		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);

    }

	handleChange = (r,selOption) => {       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}
 	};
   	handleInputChange(event) {
		const {name, value} = event.target;      
		this.setState({
			[name]: value
		});
		if (name === "secondaryColor") {			
			const hex = event.target.value;
			this.setState({ secondaryColor: hex });

			const { filter, loss } = computeFilterFromHex(hex);
			this.setState({ secondaryFilter: filter, secondaryLoss: loss });
		}	
    }


	componentDidMount() {
		document.title = PageTitle('Theme Color Edit');
    }

	handleFormSubmit = () => {
		if(this.validateForm()){ 
			this.setState({Loading:true});
			const formPayload = this.state;
			var qs = require('qs');
			var status = '';
			if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
			}else{
				status = formPayload.selectedvalue;
			}

			var postObject = {
				admin_id		: localStorage.getItem("admin_id"),
				primaryColor 	: formPayload.primaryColor,
				secondaryColor 	: formPayload.secondaryColor,
				priority		: formPayload.priority,
				secondaryFilter	: formPayload.secondaryFilter,
				status			: status,
				id				: formPayload.colorId				
			};

			let formData = new FormData();
			for(let k in postObject) {
				formData.append(k, postObject[k]);
			}		       
			axios.post(apiUrl+"themecolormanagement/edit",formData ).then(res => {
				if(res.data.status === "success"){	
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');					
					scrollToTop();
						setTimeout(
						function() {
							$('.success_message').html('');
							this.props.navigate('/themecolor');
						}
						.bind(this),
						3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(function() {
						$('.success_message').html('');
					}.bind(this),3000);
					this.setState({Loading:false});
				}
			});
		}
	}

	validateForm() {
		const {primaryColor, secondaryColor, svgImgFilter, priority} = this.state;

		let errors = {};
		let formIsValid = true;

		if(!primaryColor){
			formIsValid = false;
			$('.errorprimaryColor').html('<span class="errorspan">Please select the primary color</span>');
		}else{
			$('.errorprimaryColor').html('');
		}

		if(!secondaryColor){
			formIsValid = false;
			$('.errorsecondaryColor').html('<span class="errorspan">Please select the secondary color</span>');
		}else{
			$('.errorsecondaryColor').html('');
		}

		// Priority (must not be empty, must be a number, must be positive)
		// if (!priority) {
		// 	formIsValid = false;
		// 	$('.errorpriority').html('<span class="errorspan">Please enter priority</span>');
		// } else if (!/^\d+$/.test(priority)) {
		// 	formIsValid = false;
		// 	$('.errorpriority').html('<span class="errorspan">Priority must be a number</span>');
		// } else if (parseInt(priority, 10) <= 0) {
		// 	formIsValid = false;
		// 	$('.errorpriority').html('<span class="errorspan">Priority must be greater than 0</span>');
		// } else {
		// 	$('.errorpriority').html('');
		// }
			
		this.setState({
			errors: errors
		});
		return formIsValid;
	}
  	render() {

  	  const {selectedOption} = this.state;	

    	return (
      		<div className="wrapper"> 
	
				<Header />
				<MenuSidebar currentpage="themeColor" currentTab="common" />  
				<div className="content">	
					<div className="content-wrapper">
						<div class="content-wrapper-before"></div>
						<div className="form-wrapper leaa-admin-head card">
							<div className="success_message"></div>
							<div>
								<a class="btn" href="/themecolor">Back</a>
							</div>
							<div className="title">
								<h4>Edit Accessibility Color</h4>
							</div>
							<form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
								<div className="form-row">
									<div className="form-left">
										<div className="form-group">
											<label>Primary Color (Background)<span class="required" style={{ color: "red" }} > * </span> : </label>
											<div className='d-flex form-field-accessibility-row'>
												<div className='form-field-accessibility-input'>
													<input type="text" name="primaryColor" onChange={this.handleInputChange} className="form-control" value={this.state.primaryColor}
													
													/>
												</div>
												<div className='form-field-accessibility-colorbx'>
													<input type="color" name="primaryColor" onChange={this.handleInputChange} className="form-control" value={this.state.primaryColor}
													
													/>
												</div>
											</div>
											<div className="errorprimaryColor"></div>
										</div>	
										<div className="form-group">
											<label>Priority: </label>
											<input type="text" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
											<div className="errorpriority"></div>
										</div>
									</div>
										
									<div className="form-right">
										<div className="form-group">
											<label>Secondary Color (Text, Icons, Border)<span class="required" style={{ color: "red" }} > * </span> : </label>
											<div className='d-flex form-field-accessibility-row'>
												<div className='form-field-accessibility-input'>
													<input type="text" name="secondaryColor" onChange={this.handleInputChange} className="form-control" value={this.state.secondaryColor}
													
													/>
												</div>
												<div className='form-field-accessibility-colorbx'>
													<input type="color" name="secondaryColor" onChange={this.handleInputChange} className="form-control" value={this.state.secondaryColor}
													
													/>
												</div>
											</div>
											<div className="errorsecondaryColor"></div>
										</div>
										<div className="form-group">					
											<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
											value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
											options={lang.common.status_option} 
											onChange={this.handleChange.bind(this, 'status')}
											/>
										</div>
									</div>	
								</div>		

								<div className="btn-group export">	
									<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true? <span>updating</span>:<span>Submit</span>}
									</button>
								</div>
							</form>
						</div>				
					</div>	
				</div>
			</div>
    	);
 	}
}


export default withRouter(Edit);